import ResponsiveDoughnut from "./ResponsiveDoughnut"

export default ResponsiveDoughnut
